export const GET_SERVICE_PROVIDER_SUBSCRIPTIONS_LIST = null;
export const GET_SERVICE_PROVIDER_SUBSCRIPTION_PLAN_HISTORY_LIST = null;
export const SELECTED_SUBSCRIPTION_PLAN_DETAILS = null;
export const GET_SERVICE_PROVIDER_ORGANIZATION_SPONSORSHIP_HISTORY_LIST = null;
export const GET_SERVICE_PROVIDER_PUSH_NOTIFICATION_HISTORY_LIST = null;
